module.exports = __webpack_public_path__ + "static/media/OS2.f3b1074b.jpg";